<script setup lang="ts">
import { EmptyState } from '@design-system/vue-ui';

/**
 * EmptyState — the design-system EmptyState renders no ARIA role, so
 * role="status" is restored here for the a11y contract 013.5's deny page
 * relies on. The library's slot is named "action" (singular); this app's
 * "actions" (plural) external slot name is preserved and bridged internally.
 */
defineProps<{
  title: string;
  description?: string;
}>();
</script>

<template>
  <EmptyState :title="title" :description="description" role="status">
    <template v-if="$slots.actions" #action>
      <slot name="actions" />
    </template>
  </EmptyState>
</template>
